import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Layout from "../components/layout";
import RouterAdministracion from "./administracion/router";
// import RouterDashboard from "./dashboard/router";
// import RouterRecetas from "./recetas/router";

const RouterPage = () => {
  const { path } = useRouteMatch();
  // console.log('RouterPage ');
  // console.log(path);
  return (
    <Switch>
      <Layout>
        {/* <Route path={`${path}dashboard`}>
          <RouterDashboard />
        </Route>*/}

        <Route path={`${path}administracion`}>
          <RouterAdministracion />
        </Route>

        {/*  <Route path={`${path}recetas`}>
          <RouterRecetas />
        </Route> */}

        {/* <Route exact path={`${path}`}>
          <RouterDashboard />
        </Route> */}
      </Layout>
    </Switch>
  );
};

export default RouterPage;
